import React, { FC, ReactNode } from 'react'
import CloseIcon from 'svg/close-x.svg'
import styles from '../Filters.module.scss'
import classNames from 'classnames'
import { handleScreenReaderEnter } from 'lib/screenReader'

type FilterChipProps = {
  key?: string
  title: ReactNode
  onClose?: () => void
}

const FilterChip: FC<FilterChipProps> = ({ key, title, onClose }) => {
  return (
    <div
      key={key}
      className={classNames(styles.filterChipContainer, {
        [styles.filterChipClickable]: !!onClose,
      })}
      onClick={onClose}
      tabIndex={!!onClose ? 0 : -1}
      onKeyDown={(ev) => handleScreenReaderEnter(ev) && onClose?.()}
    >
      <span>{title}</span>
      {!!onClose && <CloseIcon />}
    </div>
  )
}

export default FilterChip
